import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { Autocomplete, TextField } from "@mui/material";
import styled from "styled-components";
import PropTypes from "prop-types";

// TODO rename stuff away from purely Peer, because this also handles showing all/unmatched
const PeerAutoSearchCompleteInput = ({ current_peer_shown }) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    loadPeers();
  }, []);

  const loadPeers = async () => {
    try {
      // This filters historical appointments; assignment pickers use the default
      // endpoint so archived peers cannot receive new work.
      const getPeersResponse = await axios.get("/peer_list.json?include_archived=true");
      const listOfPeers = getPeersResponse.data;
      const mappedListOfPeers = listOfPeers.map((user) => ({
        label: user.full_name,
        value: user.id,
        id: user.id
      }));
      const allOptions = [
        { label: "all", value: "all", id: "all" },
        { label: "unmatched", value: "unmatched", id: "unmatched" },
        ...mappedListOfPeers
      ];
      setOptions(allOptions);
    } catch (err) {
      console.log("Appiontment request autofill error: ", err);
    }
  };

  const onPeerSelected = (_, value) => {
    const currentUrl = new URL(window.location.href);
    if (!value) {
      currentUrl.searchParams.delete("what_to_show");
    } else {
      currentUrl.searchParams.set("what_to_show", value.id);
    }
    window.location.href = currentUrl.toString();
  };

  // const clearPeer = () => {
  //   const currentUrl = new URL(window.location.href);
  //   currentUrl.searchParams.delete("what_to_show");
  //   window.location.href = currentUrl.toString();
  // };

  const selectedOption = useMemo(() => {
    if (!current_peer_shown || options.length === 0) return null;
    return options.find((peer) => peer.id + "" === `${current_peer_shown}`) || null;
  }, [current_peer_shown, options]);

  return (
    <AppointmentRequestAutoFillContainer>
      <StyledAutocomplete
        options={options}
        sx={{ width: "100%" }}
        onChange={onPeerSelected}
        size="small"
        value={selectedOption}
        isOptionEqualToValue={(option, value) => !!value && option.id === value.id}
        getOptionLabel={(option) => option?.label || ""}
        clearOnEscape
        renderInput={(params) => <StyledTextField {...params} label="What to show" />}
      />
    </AppointmentRequestAutoFillContainer>
  );
};
PeerAutoSearchCompleteInput.propTypes = {
  current_peer_shown: PropTypes.string
};

const StyledTextField = styled(TextField)`
  && {
    background-color: white;
  }
`;

const StyledAutocomplete = styled(Autocomplete)`
  && {
    margin-left: 0;
  }
`;

const AppointmentRequestAutoFillContainer = styled.div`
  display: flex;
  gap: 1rem;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export default PeerAutoSearchCompleteInput;
